import Vue from 'vue';

export default {
    inserted: function (el) {
        window.addEventListener('scroll', (event) => {
            if (window.scrollY >= window.innerHeight / 2) {
                el.classList.add('opacity-100')
            } else {
                el.classList.remove('opacity-100')
            }
        })
    }
}